// Reports client — pixel-perfect documents (Typst → PDF) over governed data.
//
// The report's DEFINITION (Typst template, data query, params) lives on the
// project's Flow fork as `cortex.report.<name>.manifest`, which is why it gets
// version history for free through /api/versions/*. cortex_ops holds only the
// ACL. Rendering happens in the engine, reached through the thin
// /api/reports/engine proxy — no PDF is ever built in the browser or the backend.
import { fetchData } from '../fetchapi/fetchapi';

const json = (method, body) => ({
  method,
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});

export async function listReports() {
  return fetchData('reports');
}

// Includes the manifest read straight from the fork, so the editor always shows
// the authoritative template rather than a cortex-side copy.
export async function getReport(id) {
  return fetchData(`reports/${id}`);
}

export async function createReport(body) {
  return fetchData('reports', json('POST', body));
}

export async function updateReport(id, body) {
  return fetchData(`reports/${id}`, json('PATCH', body));
}

export async function deleteReport(id) {
  return fetchData(`reports/${id}`, { method: 'DELETE' });
}

// A report READS one or more data sources — that binding is how it gets its data:
// pick the source, then derive the SELECT against ITS schema instead of guessing
// table names into a free-text query.
export async function attachReportSource(id, sourceId) {
  return fetchData(`reports/${id}/sources/${sourceId}`, { method: 'POST' });
}

export async function detachReportSource(id, sourceId) {
  return fetchData(`reports/${id}/sources/${sourceId}`, { method: 'DELETE' });
}

// action: 'render' (full document) | 'preview' (row-capped, for the editor loop)
export async function reportEngine(action, params = {}) {
  return fetchData('reports/engine', json('POST', { action, params }));
}
